/**
 * Light tactile feedback similar to iOS UIImpactFeedbackGenerator(.light).
 * Uses the Vibration API (Android Chrome, many WebViews). iOS Safari generally
 * does not expose `navigator.vibrate`; calls are no-ops there until the platform adds support.
 */

function shouldSkip(): boolean {
  if (typeof window === "undefined") return true;
  try {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return true;
  } catch {
    /* ignore */
  }
  return false;
}

export function isHapticAvailable(): boolean {
  if (typeof navigator === "undefined") return false;
  return typeof navigator.vibrate === "function";
}

/** Default tap — subtle “light impact” (~10–15 ms). */
export function hapticLight(): void {
  if (shouldSkip() || !isHapticAvailable()) return;
  try {
    navigator.vibrate(12);
  } catch {
    /* ignore */
  }
}

/** Slightly stronger — e.g. primary / success actions (optional use). */
export function hapticMedium(): void {
  if (shouldSkip() || !isHapticAvailable()) return;
  try {
    navigator.vibrate(22);
  } catch {
    /* ignore */
  }
}
